import { createSettingsServiceApi as generatedCreateSettingsServiceApi } from '../generated/settingsServices/createSettingsService';

const createSettingsServiceApi = generatedCreateSettingsServiceApi.enhanceEndpoints({
  endpoints: {
    createSettingsService: {
      invalidatesTags: ['Services'],
    },
  },
});

export const { useCreateSettingsServiceMutation } = createSettingsServiceApi;
